module.exports = __webpack_public_path__ + "img/sand-rock-medium-02.61b81004.png";